import { IntlShape } from 'react-intl';

export const reasons = (intl: IntlShape) => [
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.stock_purchase',
            defaultMessage: 'Inventory/stock purchase'
        }),
        value: 'stock_purchase'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.bridging_loan',
            defaultMessage: 'Bridging loan'
        }),
        value: 'bridging_loan'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.marketing',
            defaultMessage: 'Marketing'
        }),
        value: 'marketing'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.equipment_purchase',
            defaultMessage: 'Equipment/building purchase'
        }),
        value: 'equipment_purchase'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.pay_bill',
            defaultMessage: 'Pay a due bill'
        }),
        value: 'pay_bill'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.pay_staff',
            defaultMessage: 'Pay staff'
        }),
        value: 'pay_staff'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.refinancing_debt',
            defaultMessage: 'Refinancing debt'
        }),
        value: 'refinancing_debt'
    },
    {
        label: intl.formatMessage({
            id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.other',
            defaultMessage: 'Other purpose'
        }),
        value: 'other'
    }
];
